import React from "react";
import { IoQrCodeOutline } from "react-icons/io5";
import { FaWhatsapp, FaRegCopy } from "react-icons/fa";
import { toastContainer } from "../../../../utils/toast";

const OtherWaysToShare = ({
  isSharable,
  shareUrl,
  copySurveyUrl,
  downloadQRCode,
  isMobile,
  setEmailSmsSendModal,
}) => {
  return (
    <>
      <div className="share_page_other_ways_to_share">
        <span className="sharepage_title">Other Ways to Share Your Trivvy</span>
      </div>

      <div
        className={` ${
          isMobile
            ? "sharepage_item_cards_parent_div_mobile"
            : "sharepage_item_cards_parent_div"
        }`}
      >
        <div
          className={`sharepage_item_card ${isSharable ? "" : "disable"}`}
          onClick={() => {
            if (isSharable) {
              setEmailSmsSendModal({ open: true, type: "COPY_LINK" });
            }
          }}
        >
          <div className="share_page_card_heading">
            <FaRegCopy className="logo-icon" /> Copy Link
          </div>
          <div className="share_page_card_description">
            Copy a link to share with anyone where you can reach them.
          </div>
        </div>

        <div
          className={`sharepage_item_card ${isSharable ? "" : "disable"}`}
          onClick={() => {
            if (isSharable) {
              setEmailSmsSendModal({ open: true, type: "QR_CODE" });
            }
          }}
        >
          <div className="share_page_card_heading">
            <IoQrCodeOutline className="logo-icon" /> QR Code
          </div>
          <div className="share_page_card_description">
            Download a QR code to share anywhere with anyone.
          </div>
        </div>

        <div
          className={`sharepage_item_card ${isSharable ? "" : "disable"}`}
          onClick={() => {
            if (isSharable) {
              setEmailSmsSendModal({ open: true, type: "WHATSAPP" });
            }
          }}
        >
          <div className="share_page_card_heading">
            <FaWhatsapp className="logo-icon" /> WhatsApp
          </div>
          <div className="share_page_card_description">
            Generate a link to share via WhatsApp.
          </div>
        </div>
      </div>
    </>
  );
};

export default OtherWaysToShare;
